export default {
   "type": "object",
   "required": [ "title", "votetype", "noofvotes", "orderseq" ],
   "properties": {
      "title": {
         "type": "string",
         "title": "Position Title",
         "default": "",
      },
      "description": {
         "type": "string",
         "title": "Description",
         "x-display": "textarea",
         "default": "",
      },
      "votetype": {
         "type": "string",
         "title": "Vote Type",
         "default": "S",
         "oneOf": [
            { "const": "S", "title": "Single Choice" },
            { "const": "M", "title": "Multiple Choice" }
         ]
      },
      "noofvotes": {
         "type": "integer",
         "title": "No. of Votes Allowed",
         "default": 1,
      },
      "orderseq": {
         "type": "integer",
         "title": "Display Order",
         "default": 1,
      },
   },
}